import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Users, BedDouble } from "lucide-react";
import "@/mockups/deepcoast.css";
import { Section, Kpi } from "@/mockups/dc";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/campaigns`;

export const MultiDogCard = ({ testid = "multi-dog-card" }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { axios.get(`${API}/multi-dog`).then((r) => setD(r.data)).catch(() => setErr("Couldn't load multi-dog households")); }, []);
  return (
    <div className="dc v3" style={{ background: "transparent", minHeight: 0 }}>
      <Section title="Multi-dog households" sub={`Owners with 2+ dogs who visited in the last 12 months. Room-nights assume 2 dogs share 1 room${d ? `, for ${d.holiday}` : ""}.`} icon={Users} testid={testid}>
        {err && <div className="alert" data-testid="multi-dog-error">{err}</div>}
        {!d && !err && <div className="skeleton" style={{ height: 110, borderRadius: 10 }} />}
        {d && (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gridAutoRows: "1fr", gap: 12 }}>
              <Kpi label="Multi-dog households" value={d.multi.toLocaleString()} sub={`${d.multi_pct}% of ${d.active_owners.toLocaleString()} active owners`} testid="multi-dog-count" />
              <Kpi label="Dogs in those homes" value={d.dogs_in_multi.toLocaleString()} sub={`≈ ${d.multi ? (d.dogs_in_multi / d.multi).toFixed(1) : 0} dogs per home`} testid="multi-dog-dogs" />
              <Kpi label="Boarded last Thanksgiving" value={d.boarded_last_holiday} sub={`${d.not_booked_holiday} not booked this year`} status={d.not_booked_holiday ? "warn" : undefined} testid="multi-dog-boarded" />
              <Kpi label="Holiday upside" value={`${d.room_nights_upside} room-nights`} sub="if those homes book again" testid="multi-dog-upside" />
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginTop: 14 }} data-testid="multi-dog-split">
              <BedDouble size={14} color="var(--accent-ink)" />
              <span className="label">Household size</span>
              {d.split.map(([l, n]) => <span key={l} className="chip"><span className="mono" style={{ fontWeight: 700 }}>{n}</span>&nbsp;{l}</span>)}
              <Link to="/campaigns?template=multi_dog_holiday" className="btn btn-primary btn-sm" style={{ marginLeft: "auto", textDecoration: "none" }} data-testid="multi-dog-build-campaign">Build campaign</Link>
            </div>
          </>
        )}
      </Section>
    </div>
  );
};
